import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import { Bar } from "react-chartjs-2";
import Loader from "components/Loader.js";

const LeadsByTagChart = ({ data, loading }) => {
    const leads = data?.leads?.byTag || [];

    // Sort by count descending and take top 10
    const sortedLeads = [...leads]
        .sort((a, b) => b.count - a.count)
        .slice(0, 10);

    const chartData = {
        labels: sortedLeads.map(l => l.tag),
        datasets: [{
            label: 'Leads',
            data: sortedLeads.map(l => l.count),
            backgroundColor: '#5e72e4',
            borderColor: '#5e72e4',
            borderWidth: 0,
            barThickness: 20
        }]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.parsed.x} leads`;
                    }
                }
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    precision: 0,
                    font: {
                        size: 12,
                        weight: 'bold'
                    }
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.15)',
                    lineWidth: 1,
                    drawBorder: true,
                    drawTicks: true
                }
            },
            y: {
                ticks: {
                    font: {
                        size: 11,
                        weight: '500'
                    }
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.08)',
                    lineWidth: 1
                }
            }
        }
    };

    return (
        <Card className="shadow" style={{ height: '500px', display: 'flex', flexDirection: 'column' }}>
            <CardHeader className="bg-transparent">
                <h6 className="text-uppercase text-muted ls-1 mb-1">Leads</h6>
                <h2 className="mb-0">Leads por Tag (Hoje)</h2>
            </CardHeader>
            <CardBody style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {loading ? (
                    <Loader variant="card" size="md" />
                ) : sortedLeads.length === 0 ? (
                    <div className="text-center p-5 text-muted">
                        <i className="ni ni-chart-bar-32 fa-3x mb-3"></i>
                        <p>Nenhum lead captado hoje</p>
                    </div>
                ) : (
                    <div style={{ width: '100%', height: '100%' }}>
                        <Bar data={chartData} options={options} />
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default LeadsByTagChart;
